import tokenProvider from 'axios-token-interceptor';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import config from '@/config';
import { getToken } from '@/apps/auth/store/state';

const instance = axios.create(config.axios);

axiosRetry(instance, {
  retries:    3,
  retryDelay: retryCount => retryCount * 1000,
});

instance.interceptors.request.use(tokenProvider({
  header:          'Authorization',
  headerFormatter: token => (token ? `Bearer ${token}` : ''),
  getToken,
}));

export default instance;



// WEBPACK FOOTER //
// ./src/api/axios.js